'use client';

import { useEffect, useState } from 'react';
import { Sheets } from './Sheets';
import { SheetsStackProps } from './Sheets.types';

export const SheetsStack = ({
  sheets,
  microcopy,
  activeIndex: controlledActiveIndex,
  className = '',
}: SheetsStackProps) => {
  const [internalActiveIndex, setInternalActiveIndex] = useState<number | null>(
    controlledActiveIndex ?? null
  );

  useEffect(() => {
    setInternalActiveIndex(controlledActiveIndex ?? null);
  }, [controlledActiveIndex]);

  return (
    <div className={className}>
      {sheets.map((sheet, index) => (
        <Sheets
          {...sheet}
          microcopy={microcopy}
          key={index}
          isFirstItem={index === 0}
          open={internalActiveIndex === index}
          onOpenChange={(open) => {
            setInternalActiveIndex(open ? index : null);
          }}
        >
          {sheet.children}
        </Sheets>
      ))}
    </div>
  );
};
